import Rectangle from "./Rectangle";
import Length from "./Length";
import Area from "./Area";
import AbstractShape from "./AbstractShape";

export default class NullShape extends AbstractShape {
	get_name() {
		return "unknown-shape";
	}

	get_required_material() {
		return new Rectangle( new Length( 0 ), new Length( 0 ) );
	}

	get_enclosing_rectangle() {
		return new Rectangle( new Length( 0 ), new Length( 0 ) );
	}

	get_area() {
		return new Area( 0 );
	}

	get_circumference() {
		return new Length( 0 );
	}

	serialize_primitives() {
		return [];
	}

	static deserialize_primitives() {
		return new NullShape();
	}

}
